import {
  makeApiCall,
  makeApiCallWithHeaders,
} from "../API/baseApi";
import { getTodayFormatted } from "../utils/utils";
import url from "./config";

const headers = {
  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
};

export const brightStarLogin = async (data) => {
  const apiUrl = `${url}/login`;
  return await makeApiCall("post", apiUrl, data);
};

export const brightStarSsoLogin = async (token) => {
  const apiUrl = `${url}/login/sso`;
  return await makeApiCall("post", apiUrl, { token });
};

export const getForgetPasswordToken = async (token) => {
  const apiUrl = `${url}/reset_password/${token}`;
  return await makeApiCall("get", apiUrl, {});
};

export const forgotPassword = async (data) => {
  const apiUrl = `${url}/reset_password`;
  return await makeApiCall("post", apiUrl, data);
};

export const getOrgDetails = async () => {
  const apiUrl = `${url}/organization_setting`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const activateUser = async (data) => {
  const apiUrl = `${url}/activate_account`;
  return await makeApiCall("post", apiUrl, data);
};

export const changePassword = async (data) => {
  const headersParam = {
    Authorization: `Bearer ${data?.token}`,
  };
  const apiUrl = `${url}/set_password`;
  return await makeApiCallWithHeaders("post", apiUrl, data?.data, headersParam);
};

export const getAllProjectList = async (id) => {
  let apiUrl;
  if (id) {
    apiUrl = `${url}/project?id=${id}&status=Active`;
  } else {
    apiUrl = `${url}/project?status=Active`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getPaginatedProjectList = async (data) => {
  let apiUrl;
  if (data?.take) {
    apiUrl = `${url}/project?skip=${data?.skip}&take=${data?.take}&status=Active`;
  } else {
    apiUrl = `${url}/project?status=Active`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getProjectDetails = async (id) => {
  const apiUrl = `${url}/project/${id}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getProjectBySearch = async (query) => {
  const apiUrl = `${url}/project/?status=Active&s=${query}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getAllAcumaticaProjects = async () => {
  const apiUrl = `${url}/project?type=acumatica&status=Active`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getAllTemporaryProjects = async () => {
  const apiUrl = `${url}/project?type=webtime&status=Active`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const addTemporaryProject = async (data) => {
  const apiUrl = `${url}/project`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const deleteProject = async (id) => {
  const apiUrl = `${url}/project/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

export const addTemporaryProjectTasks = async (data) => {
  const apiUrl = `${url}/project_task`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const getCostCodesByProjectId = async (id, is_default, query) => {
  let apiUrl;
  if (is_default) {
    apiUrl = `${url}/project_cost_code?project_id=${id}&is_default=true&${query}`;
  } else {
    apiUrl = `${url}/project_cost_code?project_id=${id}&expand=project_task`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getCostCodesByProjectTask = async (data) => {
  let apiUrl;
  if (data?.id && data?.query) {
    apiUrl = `${url}/project_cost_code?project_id=${data?.id}&${data?.query}`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getActiveCostCodes = async (crew_id) => {
  const apiUrl = `${url}/crew_project_cost_code?expand=project_cost_code&crew_id=${crew_id}&is_active=true`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const updateCostCodes = async (id, payload) => {
  const apiUrl = `${url}/project_cost_code/${id}`;
  return await makeApiCall("put", apiUrl, payload, headers);
};

export const getRoleIds = async (id) => {
  const apiUrl = `${url}/crew_role`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getProjectCrews = async (id) => {
  const apiUrl = `${url}/crew?project_id=${id}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getAllCrews = async (id, noUserExpantion) => {
  let apiUrl;
  if (id) {
    apiUrl = `${url}/crew?expand=crew_user&id=${id}`;
  } else {
    apiUrl = `${url}/crew?expand=crew_user`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getOnlyCrews = async (data) => {
  let apiUrl;
  if (data?.id) {
    apiUrl = `${url}/crew?id=${data?.id}`;
  } else if (data?.query) {
    apiUrl = `${url}/crew?${data?.query}`;
  } else {
    apiUrl = `${url}/crew`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const addCostCode = async (data) => {
  const apiUrl = `${url}/crew_project_cost_code`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const removeCostCode = async (data, id) => {
  const apiUrl = `${url}/crew_project_cost_code/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

export const getUserDetails = async (status) => {
  let apiUrl;
  if (status) {
    apiUrl = `${url}/user`;
  } else {
    apiUrl = `${url}/user?status=Active`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};
export const getProjectUserDetails = async (data) => {
  const apiUrl = `${url}/user?expand=role&status=Active`;
  return await makeApiCall("get", apiUrl, data, headers);
};

export const getUserDetailsInfo = async (id) => {
  const apiUrl = `${url}/user/${id}`;
  return await makeApiCall("get", apiUrl, id, headers);
};

export const updateUserData = async (id, data) => {
  const apiUrl = `${url}/user/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

export const getAllCrewUser = async (id) => {
  const apiUrl = `${url}/crew_user?crew_id=${id}&expand=crew_role,crew,user`;
  return await makeApiCall("get", apiUrl, id, headers);
};

export const editCrewUser = async (payload) => {
  const apiUrl = `${url}/crew_user/${payload?.id}`;
  return await makeApiCall("put", apiUrl, payload?.data, headers);
};

export const fetchAllCrewUsers = async () => {
  const apiUrl = `${url}/crew_user?expand=crew_role%2Ccrew`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getCrewUserByUserId = async (userId, crew_id) => {
  let apiUrl;
  if (crew_id) {
    apiUrl = `${url}/crew_user?crew_id=${crew_id}&user_id=${userId}&expand=crew_role%2Ccrew`;
  } else {
    apiUrl = `${url}/crew_user?user_id=${userId}&expand=crew_role%2Ccrew`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getCrewUserById = async (data) => {
  let apiUrl;
  if (data?.crew_id && data?.user_id) {
    apiUrl = `${url}/crew_user?crew_id=${data?.crew_id}&user_id=${data?.user_id}&expand=crew_role%2Cuser`;
  } else {
    apiUrl = `${url}/crew_user?id=${data?.id}&expand=crew_role%2Cuser`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const addNewCrew = async (data) => {
  const apiUrl = `${url}/crew`;
  return await makeApiCall("post", apiUrl, data, headers);
};
export const getCrewDetails = async (id) => {
  const apiUrl = `${url}/crew/${id}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getMultipleCrewDetails = async (crew_ids) => {
  let apiUrl = `${url}/crew?`;
  if (crew_ids?.length > 1) {
    const queryParams = crew_ids.map((id) => `ids[]=${id}`).join("&");
    apiUrl += queryParams;
  } else {
    crew_ids?.forEach((id) => (apiUrl += `id=${id}`));
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const addCrewUser = async (data) => {
  const apiUrl = `${url}/crew_user`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const addProjectUser = async (data) => {
  const apiUrl = `${url}/project_user`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const crewTimeEntryType = async (data) => {
  const apiUrl = `${url}/time_entry_type`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const addCrewTimeEntry = async (data) => {
  const apiUrl = `${url}/time_entry`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const getTimeSheet = async (data) => {
  const apiUrl = `${url}/time_entry`;
  return await makeApiCall("get", apiUrl, data, headers);
};

export const getProjectTimeEntries = async (queryParams) => {
  const apiUrl = `${url}/time_entry?${queryParams}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getCostCodes = async (id) => {
  const apiUrl = `${url}/project_cost_code?project_id=${id}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getProjectTask = async (id) => {
  let apiUrl;
  if (id) {
    apiUrl = `${url}/project_task?project_id=${id}`;
  } else {
    apiUrl = `${url}/project_task`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getProjectTaskAndCostCode = async (query) => {
  let apiUrl = `${url}/time_entry/task_cost_code?${query}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getCrewCostCodes = async (crew_id, enrtyType) => {
  const apiUrl = `${url}/crew_project_cost_code?expand=project_cost_code&crew_id=${crew_id}&is_active=true&type=${enrtyType}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getMyTimeSheetDetails = async (queryParams) => {
  let apiUrl = `${url}/time_sheet?expand=crew`;
  if (queryParams) {
    apiUrl = `${url}/time_sheet?expand=crew&${queryParams}`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getWeekSheet = async (week) => {
  const apiUrl = `${url}/time_sheet?expand=crew&week=${week}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const addMyTimeSheetDetails = async (data) => {
  const apiUrl = `${url}/time_sheet?expand=crew`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const updateMyTimeCardStatus = async (data, id) => {
  const apiUrl = `${url}/time_sheet/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

export const getTimeSheetByWeek = async (data, entryTypeId) => {
  const apiUrl = `${url}/time_entry/time_sheet_by_week?week=${data?.week}&crew_id=${data?.crew_id}&time_entry_type_id=${entryTypeId}&other_entries`;
  return await makeApiCall("get", apiUrl, data, headers);
};

export const getOtherEntryDetails = async (data, entryTypeId) => {
  const apiUrl = `${url}/time_entry/time_sheet_by_week?week=${data?.week}&crew_id=${data?.crewId}&time_entry_type_id=${entryTypeId}&other_entries&time_entry_id=${data?.timeEntryId}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const deleteTimeSheetEntry = async (id) => {
  const apiUrl = `${url}/time_entry/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

export const deleteCrewUser = async (id) => {
  const apiUrl = `${url}/crew_user/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};
export const deleteCrewEquipment = async (id) => {
  const apiUrl = `${url}/crew_equipment/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

export const updateTimeEntry = async (data, id) => {
  const apiUrl = `${url}/time_entry/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

export const getTimeCard = async (id) => {
  const apiUrl = `${url}/time_entry/${id}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getDailySummaryDetails = async (data) => {
  const apiUrl = `${url}/time_entry/time_sheet_daily_summary?crew_id=${data?.crew_id}&time_entry_date=${data?.time_entry_date}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getUnitJobDetails = async () => {
  const apiUrl = `${url}/check_list`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getCheckListItems = async () => {
  const apiUrl = `${url}/check_list`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const createCheckListItem = async (data) => {
  const apiUrl = `${url}/check_list`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const updateCheckListItem = async (id, data) => {
  const apiUrl = `${url}/check_list/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

export const deleteCheckListItem = async (id) => {
  const apiUrl = `${url}/check_list/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

export const listCheckListRateSheets = async (formData) => {
  const apiUrl = `${url}/check_list/rate_import/sheets`;
  return await makeApiCall("post", apiUrl, formData, headers);
};

export const previewCheckListRateImport = async (formData) => {
  const apiUrl = `${url}/check_list/rate_import/preview`;
  return await makeApiCall("post", apiUrl, formData, headers);
};

export const applyCheckListRateImport = async (formData) => {
  const apiUrl = `${url}/check_list/rate_import`;
  return await makeApiCall("post", apiUrl, formData, headers);
};

export const previewCheckListReprice = async (scope) => {
  const apiUrl = `${url}/check_list/reprice/preview`;
  return await makeApiCall("post", apiUrl, { scope }, headers);
};

export const applyCheckListReprice = async (scope) => {
  const apiUrl = `${url}/check_list/reprice`;
  return await makeApiCall("post", apiUrl, { scope }, headers);
};

export const getChecklistSubcategories = async () => {
  const apiUrl = `${url}/checklist_subcategory?expand=checklist_category`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getChecklistToSubcategories = async (query) => {
  const apiUrl = query
    ? `${url}/checklist_to_subcategory?${query}`
    : `${url}/checklist_to_subcategory`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const createChecklistToSubcategory = async (data) => {
  const apiUrl = `${url}/checklist_to_subcategory`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const updateChecklistToSubcategory = async (id, data) => {
  const apiUrl = `${url}/checklist_to_subcategory/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

export const deleteChecklistToSubcategory = async (id) => {
  const apiUrl = `${url}/checklist_to_subcategory/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

export const saveProjectCheckList = async (data) => {
  const apiUrl = `${url}/project_check_list`;
  return await makeApiCall("post", apiUrl, data, headers);
};

// `data` is forwarded to the backend verbatim (no field allow-list here), so
// the optional `status_note` carried on a status-change payload (see
// docs/TRD/checklist-status-change-notes.md §3.6/Appendix C.1) reaches the
// server without any change to this function's signature. Existing callers
// that omit `status_note` are unaffected.
export const updateProjectCheckList = async (id, data) => {
  const apiUrl = `${url}/project_check_list/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

// CLNOTE-F002: notes history for one checklist's status-change trail
// (docs/TRD/checklist-status-change-notes.md §3.7, Appendix C.3).
export const getChecklistStatusNotes = async (projectCheckListId) => {
  const apiUrl = `${url}/project_check_list_status_note?project_check_list_id=${projectCheckListId}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getProjectCheckList = async (query) => {
  let apiUrl;
  if (query) {
    apiUrl = `${url}/project_check_list?${query}`;
  } else {
    apiUrl = `${url}/project_check_list`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getProjectCheckListApproved = async (filterValue, query) => {
  let apiUrl;
    apiUrl = `${url}/project_check_list?filter=${filterValue}&${query}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const saveItemsCheckList = async (data) => {
  const apiUrl = `${url}/project_check_list_item`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const updateItemsCheckList = async (id, data) => {
  const apiUrl = `${url}/project_check_list_item/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

export const deleteItemsCheckList = async (id) => {
  const apiUrl = `${url}/project_check_list_item/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

export const getItemsCheckList = async (query) => {
  let apiUrl;
  if (query) {
    apiUrl = `${url}/project_check_list_item?${query}`;
  } else {
    apiUrl = `${url}/project_check_list_item`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

// Image Upload Section

export const uploadProjectCheckListImage = async (data) => {
  const apiUrl = `${url}/project_check_list_image/upload_file`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const getProjectCheckListImages = async (query) => {
  let apiUrl;
  if (query) {
    apiUrl = `${url}/project_check_list_image?${query}`;
  } else {
    apiUrl = `${url}/project_check_list_image`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const saveProjectCheckListImage = async (data) => {
  const apiUrl = `${url}/project_check_list_image`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const updateProjectCheckListImage = async (id, data) => {
  const apiUrl = `${url}/project_check_list_image/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

export const deleteProjectCheckListImage = async (id) => {
  const apiUrl = `${url}/project_check_list_image/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

export const deleteProjectCheckList = async (id) => {
  const apiUrl = `${url}/project_check_list/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

// export const getReviewTimeSheetsList = async (data, week_range) => {
//   console.log("week_rangeweek_range", typeof week_range);
//   let apiUrl;
//   if (
//     data?.time_sheet_status_id2 &&
//     data?.time_sheet_status_id3 &&
//     data?.crew_id &&
//     week_range !== ""
//   ) {
//     console.log("calllllllleddd");
//     apiUrl = `${url}/time_entry/review_time_sheet_summary?time_sheet_status_ids=${data?.time_sheet_status_id2}&time_sheet_status_ids=${data?.time_sheet_status_id3}&crew_id=${data?.crew_id}&${week_range}`;
//   } else if (
//     data?.time_sheet_status_id2 &&
//     data?.time_sheet_status_id3 &&
//     data?.crew_id
//   ) {
//     apiUrl = `${url}/time_entry/review_time_sheet_summary?time_sheet_status_ids=${data?.time_sheet_status_id2}&time_sheet_status_ids=${data?.time_sheet_status_id3}&crew_id=${data?.crew_id}`;
//   } else if (data?.time_sheet_status_id2 && data?.time_sheet_status_id3) {
//     apiUrl = `${url}/time_entry/review_time_sheet_summary?time_sheet_status_ids=${
//       data?.time_sheet_status_id2
//     }&time_sheet_status_ids=${data?.time_sheet_status_id3}&${
//       week_range ? week_range : ""
//     }`;
//   } else if (data?.time_sheet_status_id4) {
//     apiUrl = `${url}/time_entry/review_time_sheet_summary?time_sheet_status_ids=${
//       data?.time_sheet_status_id4
//     }&${week_range ? week_range : ""}`;
//   }
//   return await makeApiCall("get", apiUrl, {}, headers);
// };

export const getReviewTimeSheetsList = async (queryParams) => {
  let apiUrl = `${url}/time_entry/review_time_sheet_summary`;
  if (queryParams) {
    apiUrl = `${url}/time_entry/review_time_sheet_summary?${queryParams}`;
  }

  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getWeeklyTotals = async (data) => {
  const apiUrl = `${url}/time_entry/time_sheet_weekly_summary?crew_id=${data?.crew_id}&week=${data?.week}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

// Equipment
export const getCrewEquipmentList = async (id) => {
  const apiUrl = `${url}/crew_equipment?expand=crew%2Cequipment&crew_id=${id}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getAllEquipmentList = async () => {
  const apiUrl = `${url}/equipment?status=Active`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const addCrewEquipment = async (data) => {
  const apiUrl = `${url}/crew_equipment?expand=crew%2Cequipment`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const getCrewEquipmentById = async (data) => {
  let apiUrl;
  if (data?.crew_id && data?.equipment_id) {
    apiUrl = `${url}/crew_equipment?crew_id=${data?.crew_id}&equipment_id=${data?.equipment_id}&expand=crew%2Cequipment`;
  } else {
    apiUrl = `${url}/crew_equipment?id=${data?.id}&expand=crew%2Cequipment`;
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const editCrewEquipment = async (payload) => {
  const apiUrl = `${url}/crew_equipment/${payload?.id}`;
  return await makeApiCall("put", apiUrl, payload?.data, headers);
};

export const mergeProjectAndTasks = async (data) => {
  const apiUrl = `${url}/project/merge`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const downloadReport = async (payload) => {
  const responseType = "blob";
  const apiUrl = `${url}/time_entry_report/get_review_report?week=${payload?.week}&crew_id=${payload?.crew_id}`;
  return await makeApiCall("get", apiUrl, {}, headers, responseType);
};
export const getTimeEntryColor = async (sheet_id, day) => {
  const apiUrl = `${url}/time_entry/day_summary?time_sheet_id=${sheet_id}&today=${day}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getDaySummary = async (sheet_ids) => {
  const today = getTodayFormatted();
  let apiUrl = `${url}/time_entry/day_summary?today=${today}`;
  if (sheet_ids?.length === 1) {
    sheet_ids?.forEach((ele) => (apiUrl += `&time_sheet_id=${ele?.id || ele?.time_sheet_id}`));
  } else if (sheet_ids?.length > 1) {
    sheet_ids?.forEach((ele) => (apiUrl += `&time_sheet_ids[]=${ele?.id || ele?.time_sheet_id}`));
  }
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const DeleteMyTimeSheetDetails = async (id) => {
  const apiUrl = `${url}/time_sheet/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

export const getWeeklySummary = async (id) => {
  const apiUrl = `${url}/weekly_summary?time_sheet_id=${id}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};
export const addWeeklySummary = async (data) => {
  const apiUrl = `${url}/weekly_summary`;
  return await makeApiCall("post", apiUrl, data, headers);
};

export const upateWeeklySummary = async (data, id) => {
  const apiUrl = `${url}/weekly_summary/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};
export const DeleteWeeklySummary = async (id) => {
  const apiUrl = `${url}/time_sheet/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

export const downloadCustomerReport = async (data) => {
  const responseType = "blob";
  const apiUrl = `${url}/customer_report/customized`;
  return await makeApiCall("post", apiUrl, data, headers, responseType);
};
export const downloadAllReport = async (data) => {
  const responseType = "blob";
  const apiUrl = `${url}/customer_report/all`;
  return await makeApiCall("post", apiUrl, data, headers, responseType);
};
export const updateCrewDetails = async (data, id) => {
  const apiUrl = `${url}/crew/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};
export const downloadUnitJobReport = async (project_check_list_id, project_check_list_image_ids, type) => {
  const responseType = "blob";
  const apiUrl = `${url}/project_check_list_report/${type}?project_check_list_id=${project_check_list_id}&project_check_list_image_ids=${project_check_list_image_ids}`;
  return await makeApiCall("get", apiUrl, {}, headers, responseType);
};

export const getMetabaseReport = async (/* parameters */) => {
  const apiUrl = `${url}/metabase_report`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getMetabaseReportById = async (id, qs) => {
  const apiUrl = `${url}/metabase_report/${id}?${qs}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getLastWorkedOn = async () => {
  const apiUrl = `${url}/project_check_list/last_worked_on`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getChecklistCategory = async () => {
  const apiUrl = `${url}/checklist_category`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getChecklistSubcategory = async () => {
  const apiUrl = `${url}/checklist_subcategory`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getChecklistToSubcategory = async () => {
  const apiUrl = `${url}/checklist_to_subcategory?expand=checklist_subcategory`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

// Checklist comments (CLCMT-F002, docs/TRD/checklist-comments.md §3.8,
// Appendix C). Author expansion and is_own are always present server-side —
// no `?expand=` needed. Ordering (created_at ASC, id ASC) is server-side and
// must never be re-sorted client-side (AC-F3.2).
export const getChecklistComments = async (projectCheckListId) => {
  const apiUrl = `${url}/project_check_list_comment?project_check_list_id=${projectCheckListId}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

// Accepts a single id or an array of ids (P1/F7 batches the whole board into
// one request — Appendix C.2). The server returns one grouped query either
// way; this helper only shapes the query string.
export const getChecklistCommentCount = async (projectCheckListIds) => {
  const ids = Array.isArray(projectCheckListIds)
    ? projectCheckListIds.join(",")
    : projectCheckListIds;
  const apiUrl = `${url}/project_check_list_comment/count?project_check_list_ids=${ids}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

// `data` must be `{ project_check_list_id, comment }` only — the server
// stamps `created_by` from the authenticated user, and a `created_by` in the
// body is never read (AC-F2.4, AC-F6.2).
export const createChecklistComment = async (data) => {
  const apiUrl = `${url}/project_check_list_comment`;
  return await makeApiCall("post", apiUrl, data, headers);
};

// `data` is `{ comment }` only in P0 (AC-F4.6); P1/F10 adds an optional
// `expected_edited_at` for the stale-edit precondition (CLCMT-F011) — not
// sent by this release.
export const updateChecklistComment = async (id, data) => {
  const apiUrl = `${url}/project_check_list_comment/${id}`;
  return await makeApiCall("put", apiUrl, data, headers);
};

// Soft delete — the row is retained server-side with `deleted_at` set
// (NG8, AC-F5.6).
export const deleteChecklistComment = async (id) => {
  const apiUrl = `${url}/project_check_list_comment/${id}`;
  return await makeApiCall("delete", apiUrl, {}, headers);
};

// Notification bell — P0 client functions (NOTIFY-F001,
// docs/TRD/task-notifications-contract.md §3, §7.1). No endpoint accepts an
// owner/recipient/organization id from the client — the caller is always
// resolved server-side from the bearer token — so none of these functions
// take or send one.
//
// `makeApiCall`'s real signature is `(method, url, data, headers,
// responseType)` — the 5th argument is `responseType`, not query params
// (contract §7.1's implementer caution). Any query string is built onto the
// URL itself instead.
export const getNotifications = async ({ limit, offset, unread_only } = {}) => {
  const params = new URLSearchParams();
  if (limit !== undefined) params.set("limit", limit);
  if (offset !== undefined) params.set("offset", offset);
  // @IsBooleanString on the backend — send the string 'true'/'false', not a
  // JS boolean.
  if (unread_only !== undefined) params.set("unread_only", String(unread_only));
  const query = params.toString();
  const apiUrl = `${url}/notification${query ? `?${query}` : ""}`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const getUnreadCount = async () => {
  const apiUrl = `${url}/notification/unread_count`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

export const markNotificationRead = async (id) => {
  const apiUrl = `${url}/notification/${id}/read`;
  return await makeApiCall("put", apiUrl, {}, headers);
};

export const markAllNotifications = async () => {
  const apiUrl = `${url}/notification/read_all`;
  return await makeApiCall("put", apiUrl, {}, headers);
};

// Push (P1) — NOTIFY-F006/F007, docs/TRD/task-notifications-contract.md §6, source TRD
// §3.8. Same `makeApiCall` signature caution as above (no query-string args here — these
// three take no query params at all). Named `getPushPublicKey` / `subscribePush` /
// `unsubscribePush` per the task's naming (the source TRD sketches `subscribeToPush` /
// `unsubscribeFromPush`; this repo's client keeps the shorter pair).
export const getPushPublicKey = async () => {
  const apiUrl = `${url}/push/public-key`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

// `data` is `{ endpoint, keys: { p256dh, auth }, user_agent }` (contract §6).
export const subscribePush = async (data) => {
  const apiUrl = `${url}/push_subscription`;
  return await makeApiCall("post", apiUrl, data, headers);
};

// `DELETE /api/push_subscription` takes its `endpoint` in the request body, not the URL
// (contract §6) — axios sends a DELETE body via `config.data`, which `makeApiCall`'s `data`
// argument already maps to.
//
// Review fix (NOTIFY-F008, I1/I2): turning the in-app preference off (PushSettings.js
// handleTogglePreference) must NEVER call this — AC-F10.4 requires the browser
// subscription and the server's subscription row to stay intact so re-enabling resumes
// delivery with no permission re-prompt. This export exists for a real unsubscribe (e.g. a
// future "forget this device" action), not for the preference toggle.
export const unsubscribePush = async (endpoint) => {
  const apiUrl = `${url}/push_subscription`;
  return await makeApiCall("delete", apiUrl, { endpoint }, headers);
};

// NOTIFY-F008 — GET/PUT /api/notification_preference (contract §6, source TRD NOTIFY-B013).
// Server-side preference, so it follows the user across browsers. No query params on the
// GET (no ad-hoc 5th `responseType` arg per the task's house rule).
export const getNotificationPreference = async () => {
  const apiUrl = `${url}/notification_preference`;
  return await makeApiCall("get", apiUrl, {}, headers);
};

// `data` is `{ push_enabled }` (contract §6).
export const setNotificationPreference = async (data) => {
  const apiUrl = `${url}/notification_preference`;
  return await makeApiCall("put", apiUrl, data, headers);
};
